import { useLayoutEffect } from 'react';
import { css } from '@emotion/react';
import { MultiStep, useMultiStepControl } from '@frontend/design-system';
import {
  CareCreditCollectMultiStepBaseProps,
  CareCreditCollectMultiSteps,
} from './care-credit-collect-multi-step/collect-multi-step.types';
import { CareCreditCollectProvider } from './care-credit-collect-multi-step/context/care-credit-collect.provider';
import { Step1SelectPaymentMethod } from './care-credit-collect-multi-step/steps/step1-select-payment-method';
import { Step2PaymentMethodForm } from './care-credit-collect-multi-step/steps/step2-payment-method-form';
import { Step3SelectFinanceOption } from './care-credit-collect-multi-step/steps/step3-select-finance-option';
import { Step4ReceiptOptions } from './care-credit-collect-multi-step/steps/step4-receipt-options';
import { getCollectSteps } from './care-credit-collect-multi-step/utils/get-collect-steps';

const PARENT_TOPBAR_HEIGHT = 64;

const styles = {
  multiStepOverrides: css`
    .multi-step__body-wrapper {
      background: transparent;
    }

    .step {
      max-height: calc(100vh - ${48 + PARENT_TOPBAR_HEIGHT}px);
      min-height: ${500 - PARENT_TOPBAR_HEIGHT}px;
      gap: 0;
      margin-bottom: 0;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
    .step__body {
      margin-bottom: 0;
    }
  `,
};

export type CareCreditCollectMultiStepProps = CareCreditCollectMultiStepBaseProps & {
  className?: string;
};

export const CareCreditCollectMultiStep = ({
  className,
  multiStepProps,
  trackingId = 'cc-collect-generic',
  ...props
}: CareCreditCollectMultiStepProps) => {
  const initialActiveStep: CareCreditCollectMultiSteps = 'select-payment-method';

  const multiStepControl = useMultiStepControl({
    initialActiveStep,
    stepper: { show: false },
    isInModal: true,
    trackingId,
    ...multiStepProps,
  });

  useLayoutEffect(() => {
    multiStepControl.setSteps(getCollectSteps());
  }, []);

  return (
    <CareCreditCollectProvider {...props} multiStepControl={multiStepControl}>
      <MultiStep.Root
        {...multiStepControl}
        trackingId={trackingId || multiStepControl.trackingId}
        className={className}
        css={styles.multiStepOverrides}
      >
        <Step1SelectPaymentMethod />
        <Step2PaymentMethodForm />
        <Step3SelectFinanceOption />
        <Step4ReceiptOptions />
      </MultiStep.Root>
    </CareCreditCollectProvider>
  );
};
